export default function formatSessionStatus(status) {
  switch (status) {
    case "no_show":
      return "No Show";
    case "late_cancel":
      return "Late Cancel";
    case "complete":
      return "Complete";
    case "cancel":
      return "Cancel";
    case "cancel_by_patient": // TODO: this is a FE hack since BE does not support canceling reason for non-invoiced invoicing sessions
      return "Cancel by Patient";
    default:
      return "Complete";
  }
}
